export enum LocalEnum {
    user= 'op.user',
    isloggedin= 'op.islogged',
    token= 'op.token',
    url = 'op.url',
    customHeader='op.customHeader',
    oppUser= 'userDetail',
    tenantData = 'tenantData'
  }
  